import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessOfferManagerHandler {
 	url: any;
 	token: any;
  	businessId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getOffers(cb){	
	  	this.url = this.globals.dataUrl + 'businessOffer';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

  	getOffer(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessOffer/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

	createOffer(params, cb){
	    this.url = this.globals.dataUrl + 'businessOffer';

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    });  
		})           
	}

	deleteOffer(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessOffer/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.delete(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res);
		    });   
    	})
  	}

	updateOffer(id, params, cb){
	    this.url = this.globals.dataUrl + 'businessOffer/' + id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    }); 
		});             
	}

  	uploadOfferImage(params){		
	  	this.url = this.globals.dataUrl + 'businessOffer/image';

    	this.storage.get('loginData').then((loginData) => {
    		console.log("||Before post||");

    		console.log(params.imageString);
    		
		    this.http.post(
		        this.url,
		        {ImagePath: params.imageString,
		         OfferId: params.id}, 
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => {
		    	console.log("||Mapping||");
		    	console.log("||Status||");
		    	console.log(res.status);
			    // If request fails, throw an Error that will be caught
			    if(res.status < 200 || res.status >= 300) {
			      throw new Error('This request has failed ' + res.status);
			    } 
			    // If everything went fine, return the response
			    else {
			      return res.json();
			    }
			})
		    .subscribe(
				(res) => {
					console.log("Returned data:");
					console.log(res);					
					if(typeof params.cb == "function") params.cb(res);
				}, 
				(err) => {
					console.log("Returned error:");
					console.log(err);
				}
		    );   
    	})
  	}

  	deleteImage(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessOffer/image/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.delete(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res);
		    });   
    	})
  	}

  	activateOffer(params){
	    this.url = this.globals.dataUrl + 'businessOffer/offer/' + params.id + '/activate/' + params.activate;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      null, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    }); 
		});             
	}	
}



// WEBPACK FOOTER //
// ./src/providers/business-offer-handler.ts